<template>
  <section id="projects" class="gallery">
    <h1>{{ $t('DStudioGalleryTitle') }}</h1>
    <div class="body">
      <UiSliderV2
        :items="galleryList"
        maxWidth="1184px"
        minWidth="1154px"
        minHeight="initial"
        :borderRadius="16"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;

const galleryList = [
  {
    name: 'DStudioGalleryProject6Title',
    content: [
      {
        id: 1,
        title: 'DStudioGalleryProject6Title',
        description: 'DStudioGalleryProject6Subtitle',
        images: [
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-1-1.webp`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-1-2.webp`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-1-3.webp`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-1-4.png`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-1-5.png`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-1-6.png`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-1-7.png`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-1-8.png`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-1-9.png`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-1-10.png`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-1-11.png`,
        ],
        video: [
          {
            src: `${staticUrl}/video/ds-gallery-2-video-1-1.mp4`,
            srcMobile: `${staticUrl}/video/ds-gallery-2-video-1-1_mobile.mp4`,
          },
          {
            src: `${staticUrl}/video/ds-gallery-2-video-1-2.mp4`,
            srcMobile: `${staticUrl}/video/ds-gallery-2-video-1-2_mobile.mp4`,
          },
          {
            src: `${staticUrl}/video/ds-gallery-2-video-1-3.mp4`,
            srcMobile: `${staticUrl}/video/ds-gallery-2-video-1-3_mobile.mp4`,
          },
          {
            src: `${staticUrl}/video/ds-gallery-2-video-1-4.mp4`,
            srcMobile: `${staticUrl}/video/ds-gallery-2-video-1-4.mp4`,
          },
          {
            src: `${staticUrl}/video/ds-gallery-2-video-1-5.mp4`,
            srcMobile: `${staticUrl}/video/ds-gallery-2-video-1-5.mp4`,
          },
        ],
        tour: '/tours/Tour_from_06.03.2024_20-21-48-954/index.htm?n=3',
      },
    ],
  },
  {
    name: 'DStudioGalleryProject7Title',
    content: [
      {
        id: 1,
        title: 'DStudioGalleryProject7Title',
        description: 'DStudioGalleryProject7Subtitle',
        images: [
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-2-1.webp`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-2-2.webp`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-2-3.webp`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-2-4.png`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-2-5.webp`,
          `${staticUrl}/images/design-studio/ds-gallery-2-photo-2-6.webp`,
        ],
        video: [
          {
            src: `${staticUrl}/video/ds-gallery-2-video-2-1.mp4`,
            srcMobile: `${staticUrl}/video/ds-gallery-2-video-2-1_mobile.mp4`,
          },
          {
            src: `${staticUrl}/video/ds-gallery-2-video-2-2.mp4`,
            srcMobile: `${staticUrl}/video/ds-gallery-2-video-2-2_mobile.mp4`,
          },
          {
            src: `${staticUrl}/video/ds-gallery-2-video-2-3.mp4`,
            srcMobile: `${staticUrl}/video/ds-gallery-2-video-2-3_mobile.mp4`,
          },
          {
            src: `${staticUrl}/video/ds-gallery-2-video-2-4.mp4`,
            srcMobile: `${staticUrl}/video/ds-gallery-2-video-2-4.mp4`,
          },
        ],
        tour: '/tours/Tour_from_05.03.2024_18-22-05-309/index.htm?n=3',
      },
    ],
  },
];
</script>

<style scoped lang="scss">
.gallery {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-top: $m-45;

  .body {
    display: flex;
    flex-direction: column;
    gap: $g-4;
    margin-top: $m-12;

    .card-classic {
      align-items: unset;
      h3 {
        @include headline-h3;
        margin: 0px;
        margin-bottom: $m-3;
        color: var(--var-black-100);
      }
      p {
        @include launcher-p1;
        color: var(--var-black-200);
        margin: 0px;
        margin-top: $m-3;
      }
      h4 {
        @include launcher-p1;
        font-weight: $fw-600;
        color: var(--var-black-100);
        margin: 0px;
        margin-top: $m-3;
      }
    }

    @media (max-width: $md) {
      margin-top: 0;
    }
  }

  @media (min-width: 2000px) {
    min-height: unset;
  }
  @media (max-width: $lg) {
    width: 100%;
  }
  @media (max-width: $md) {
    gap: $g-5;
    margin-top: $m-40;
  }

  h1 {
    @include title-fw-700-fs-56-black-100;
    margin: 0px;
  }
}
</style>
